module.exports = __webpack_public_path__ + "img/26.b7e1ebbe.jpg";